import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { CustomerType } from '@partners/customer-type.enum';

export const defaultRoute = (isOptimizationHubEnabled: boolean, customerType: CustomerType): string => {
	let defaultRoute: string;

	if (customerType === CustomerType.BO) {
		defaultRoute = AppRouteHelper.controlPanelOrganizations;
	} else if (isOptimizationHubEnabled) {
		defaultRoute = AppRouteHelper.home;
	} else {
		defaultRoute = AppRouteHelper.dashboard;
	}
	return defaultRoute;
};
